import { defineMessages } from 'react-intl';

const messages = defineMessages({
  successHeader: {
    id: 'App.PrimaryLeaseApplication.SuccessHeader',
    defaultMessage: 'Success',
  },
  progressSuccessDescription: {
    id: 'App.PrimaryLeaseApplication.ProgressSuccessDescription',
    defaultMessage: 'Lease application saved successfully.',
  },
  completionSuccessDescription: {
    id: 'App.PrimaryLeaseApplication.CompletionSuccessDescription',
    defaultMessage: 'Lease application completed successfully.',
  },
  errorHeader: {
    id: 'App.PrimaryLeaseApplication.errorHeader',
    defaultMessage: 'Error',
  },
  confirmDeleteMinors: {
    id: 'App.PrimaryLeaseApplication.ConfirmDeleteMinors',
    defaultMessage: "Are you sure you want to delete the applicant's minor(s)?",
  },
  confirmDeletePets: {
    id: 'App.PrimaryLeaseApplication.ConfirmDeletePets',
    defaultMessage: "Are you sure you want to delete the applicant's pet(s)?",
  },
  completeDocumentTitle: {
    id: 'App.PrimaryLeaseApplication.CompleteDocument.Title',
    defaultMessage: 'Complete Document',
  },
  completeDocumentSubtitle: {
    id: 'App.PrimaryLeaseApplication.CompleteDocument.Subtitle',
    defaultMessage: 'Send for signature',
  },
  completeDocumentDescription: {
    id: 'App.PrimaryLeaseApplication.CompleteDocument.Description',
    defaultMessage:
      'Send the form to the applicant’s portal for electronic signing. ' +
      'They will receive a text message and email notifying them of the change. ' +
      'If they don’t yet have an account they’ll also receive and invitation to join.',
  },
  saveAndCompleteButton: {
    id: 'App.PrimaryLeaseApplication.CompleteDocument.SaveAndComplete',
    defaultMessage: 'Save & Complete',
  },
  saveAndCompleteDescription: {
    id: 'App.PrimaryLeaseApplication.CompleteDocument.SaveAndCompleteDescription',
    defaultMessage:
      'This will finalize the document and save your changes without sending it for signature.',
  },
  sendForSignatureButton: {
    id: 'App.PrimaryLeaseApplication.CompleteDocument.SendForSignature',
    defaultMessage: 'Send for Signature',
  },
  completeConfirmation: {
    id: 'App.PrimaryLeaseApplication.CompleteDocument.CompleteConfirmation',
    defaultMessage: 'Are you sure you want to complete this application?',
  },
});

export default messages;
